import { FC, lazy } from 'react';

import { Login } from '@/modules/login';

export const LoginPage: FC = () => <Login />;

export const LoginPageLazy = lazy(async () => {
    const { LoginPage } = await import('./page');

    return { default: LoginPage };
});
